import { stateOptions } from "../commonStateTaxData";
import { INTEGER_REGEX_STR, US_ZIPCODE_REGEX_STR } from "../helpers";

export const questions = [
  {
    id: "employee_first_name_middle_initial",
    title: "First name and middle initial",
    is_required: true,
    question_type: "short_text",
  },
  {
    id: "employee_last_name",
    title: "Last name",
    is_required: true,
    question_type: "short_text",
  },
  {
    id: "taxpayer_id",
    title: "Taxpayer ID",
    is_required: true,
    question_type: "short_text",
  },
  {
    id: "street_address",
    title: "Home address (number and street or rural route)",
    is_required: true,
    question_type: "short_text",
  },
  {
    id: "city_or_town",
    title: "City or town",
    is_required: true,
    question_type: "short_text",
  },
  {
    id: "state",
    title: "State",
    is_required: true,
    question_type: "dropdown",
    options: stateOptions,
  },
  {
    id: "zip_code",
    title: "Zip code",
    is_required: true,
    question_type: "short_text",
    placeholder: "5 digits",
    rules: [
      {
        category: "regex",
        action: "match",
        value: US_ZIPCODE_REGEX_STR,
      },
    ],
  },
  {
    id: "filing_status",
    title: "Filing status",
    is_required: true,
    question_type: "multiple_choice",
    options: [
      {
        codeValue: "single",
        shortName: "Single",
      },
      {
        codeValue: "married",
        shortName: "Married",
      },
    ],
  },
  {
    id: "dependents",
    title: "Total number of dependents you can claim on your return",
    question_type: "short_text",
    rules: [
      {
        category: "regex",
        action: "match",
        value: INTEGER_REGEX_STR,
      },
    ],
  },
  {
    id: "additional_amount",
    title: "Additional amount, if any, you want withheld from each paycheck",
    question_type: "short_text",
    rules: [
      {
        category: "regex",
        action: "match",
        value: INTEGER_REGEX_STR,
      },
    ],
  },
];
